export default function CategoryTag({ label }) {
  return (
    <span className="section-tag marketing-category-tag">
      <span className="marketing-eyebrow__dot marketing-eyebrow__dot--sm" aria-hidden="true" />
      {label}
    </span>
  );
}
